import axios from "axios";
import {WarehouseDashboardModelAPIsConstants} from "@/views/modules/warehouse/store/enums/WarehouseDashboardModelEnum";

const WarehouseDashboardModule = {
    namespaced: true,
    state: {
        dashboardValues: {},
        warehouseDashboardValues: {},
        loading: false,
        crudLoading: false,
        loadingItem: false,
    },
    mutations: {
        SET_WAREHOUSE_DASHBOARD_MODEL_DATA(state, payload) {
            state.warehouseDashboardValues = payload.item;
        },
        SET_LOADING(state, payload) {
            state.loading = payload;
        },
        SET_CRUD_LOADING(state, payload) {
            state.crudLoading = payload;
        },
        SET_LOADING_ITEM(state, payload) {
            state.loadingItem = payload;
        },
        RESET_ALL(state) {
            state.loading = false;
            state.dashboardValues = {};
        },
    },
    actions: {
        getWarehouseStatisticData({commit, dispatch}) {
            commit('SET_LOADING',true)
            return new Promise((resolve, reject) => {
                axios.get(`${WarehouseDashboardModelAPIsConstants.API_PATH}/get-warehouse-statistic-data`)
                    .then((response) => {
                        commit('SET_WAREHOUSE_DASHBOARD_MODEL_DATA', {
                            item: response.data.result
                        });
                        commit('SET_LOADING',false)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_LOADING',false)
                        reject(error)
                    })
            })
        },
        
    },
    getters: {}
}

export default WarehouseDashboardModule
